import { TestSuite } from "@app.raytd.com/common/types/test-suite";
import { getFieldSetting } from "@app.raytd.com/common/utils/test-suites/getFieldSetting";
import { TestSuiteType } from "@app.raytd.com/common/types/test-suite-types";

function isFieldVisible(testSuite: Pick<TestSuite, 'type' | 'settings'> | null, fieldName: string) {
    if (!testSuite) return true;

    const fieldSettings = getFieldSetting(
        fieldName,
        testSuite.type as TestSuiteType,
        testSuite.settings || []
    );

    return fieldSettings.active;
}

export default isFieldVisible;